import React, { useEffect, useMemo, useState} from "react";
import ControlPanel from "../../components/Analytics/groupAnalysis/ControlPanel"
import B2BApiService from "../../B2bApiService";
import {useSelector} from "react-redux";
import { lookups, t } from '../../content';
import { useLocale } from '../../locale';
import RadarChart from "../../components/reusableElementsComponents/RadarChart";
import {Select} from "../../components/formComponents/Inputs";
import TeamSimulatorVerticalCharts from "../../components/teamReviewComponents/teamSimulatorVerticalChart";
import {MotivationCharts} from "../../components/Analytics/keyAnalytics/MotivationCharts";
import {CommonCompetencies, CommonBehaviours} from "../../components/Analytics/keyAnalytics/Charts";
import { convertLabelsToArrayOfWords } from "../../Utilities";
import * as Constants from "../../constants";

function TeamSimulatorPage() {
    useLocale();
    // const contentfulData = useSelector(state => state.contentfulData.all['talent-data']?.fields);
    const contentfulData = {
        teamStrengthsLabels: lookups.teamStrengthLabels,
        salesStrengthsLabels: lookups.salesStrengthLabels,
    };

    const companyData = useSelector(state => state.company.info);

    const optionsSalesDropdown = [
        { id: 'Competency', title: t('analytics.types.competency') },
        { id: 'Attitude', title: t('analytics.types.attitude') }
    ];

    const [lightOptionsTeams] = useState({
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                },
                position: 'bottom'
            }
        },
        scales: {
            r: {
                min: 0,
                max: 9,
                ticks: {
                    stepSize: 1, // the number of step
                },
                pointLabels: {
                    fonfontSize: 14,
                    color: '#495057',
                    padding: 0,
                    margin: 0
                },
                grid: {
                    color: '#ebedef',
                    circular: true
                },
                angleLines: {
                    color: '#ebedef'
                }
            }
        }
    });
    const [lightOptionsSales] = useState({
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                },
                position: 'bottom',
            }
        },
        scales: {
            r: {
                max: 5,
                min: 0,
                stepSize: 1,
                ticks: {
                    stepSize: 1, // the number of step
                },
                pointLabels: {
                    fonfontSize: 14,
                    color: '#495057',
                    padding: 0,
                    margin: 0
                },
                grid: {
                    color: '#ebedef',
                    circular: true
                },
                angleLines: {
                    color: '#ebedef'
                }
            }
        }
    });

    const [selectedCandidates, setSelectedCandidates] = useState([]);
    const [groupA, setGroupA] = useState([]);
    const [groupB, setGroupB] = useState([]);
    const [groupEditedFlag, setGroupEditedFlag] = useState(false);
    const [fetchDataErrorMessage, setFetchDataErrorMessage] = useState("");

    // Analysis Data States
    const [analysisData, setAnalysisData] = useState(null);

    // COMPETENCIES
    const [averageCompetenciesData, setAverageCompetenciesData] = useState(null);
    const [allGroupAUserCompetencies, setAllGroupAUserCompetencies] = useState(null);
    const [allGroupBUserCompetencies, setAllGroupBUserCompetencies] = useState(null);
    const [competenciesGroupAFocused, setCompetenciesGroupAFocused] = useState({
        labels: [], groupAData: [], groupBData: []
    });
    const [competenciesGroupBFocused, setCompetenciesGroupBFocused] = useState({
        labels: [], groupAData: [], groupBData: []
    });
    let [top5Competencies, setTop5Competencies] = useState([]); // if there is only one group
    let [bottom5Competencies, setBottom5Competencies] = useState([]); // if there is only one group

    // MOTIVATIONS
    const [averageMotivationsData, setAverageMotivationsData] = useState(null);
    const [allGroupAUserMotivations, setAllGroupAUserMotivations] = useState(null);
    const [allGroupBUserMotivations, setAllGroupBUserMotivations] = useState(null);
    const [motivationsGroupAFocused, setMotivationsGroupAFocused] = useState({
        labels: [], groupAData: [], groupBData: []
    });
    const [motivationsGroupBFocused, setMotivationsGroupBFocused] = useState({
        labels: [], groupAData: [], groupBData: []
    });
    let [top5Motivations, setTop5Motivations] = useState([]); // if there is only one group
    let [bottom5Motivations, setBottom5Motivations] = useState([]); // if there is only one group

    // BEHAVIOURS
    const [averageBehavioursData, setAverageBehavioursData] = useState(null);
    const [allGroupAUserBehaviours, setAllGroupAUserBehaviours] = useState(null);
    const [allGroupBUserBehaviours, setAllGroupBUserBehaviours] = useState(null);
    const [behavioursGroupAFocused, setBehavioursGroupAFocused] = useState({
        labels: [], groupAData: [], groupBData: []
    });
    const [behavioursGroupBFocused, setBehavioursGroupBFocused] = useState({
        labels: [], groupAData: [], groupBData: []
    });
    let [top5Behaviours, setTop5Behaviours] = useState([]); // if there is only one group
    let [bottom5Behaviours, setBottom5Behaviours] = useState([]); // if there is only one group

    // TEAM STRENGTHS 
    const [groupATeamChartData, setGroupATeamChartData] = useState({
        labels: contentfulData?.teamStrengthsLabels,
        datasets: []
    });

    const [groupBTeamChartData, setGroupBTeamChartData] = useState({
        labels: contentfulData?.teamStrengthsLabels,
        datasets: []
    });

    // SALES STRENGTHS
    const [groupASalesOption, setGroupASalesOption] = useState('Competency');
    const [groupBSalesOption, setGroupBSalesOption] = useState('Competency');

    const [groupASalesChartData, setGroupASalesChartData] = useState({
        labels: contentfulData?.salesStrengthsLabels,
        datasets: {
            Competency: { datasets: [] },
            Attitude: { datasets: [] }
        }
    });

    const [groupBSalesChartData, setGroupBSalesChartData] = useState({
        labels: contentfulData?.salesStrengthsLabels,
        datasets: {
            Competency: [],
            Attitude: []
        }
    });
    // Ending of data states

    useEffect(() => {
        if(groupA.length === 0 && groupB.length === 0){
            setGroupEditedFlag(false);
        }
    }, [groupA, groupB]);

    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    },[]);

    const formulateBarChartData = (data, focusedGroupKey, otherGroupKey) => {
        const focusedGroup = data[focusedGroupKey]; // e.g., group A or group B
        const otherGroup = data[otherGroupKey]; // e.g., group B or group A

        // Defensive checks: ensure that focusedGroup and otherGroup are valid arrays
        if (!Array.isArray(focusedGroup)) {
            return { focusedGroupTop5: [], focusedGroupBottom5: [], columnNames: [], otherGroupValues: [] };
        }
        if (!Array.isArray(otherGroup)) {
            return { focusedGroupTop5: [], focusedGroupBottom5: [], columnNames: [], otherGroupValues: [] };
        }

        // Ensure focusedGroup has enough data to slice top and bottom 4
        const sortedfocusedGroup = [...focusedGroup].sort((a, b) => b.average - a.average);
        const focusedGroupTop5 = sortedfocusedGroup.slice(0, 5); // Get first 5 elements, from high to low
        const focusedGroupBottom5 = sortedfocusedGroup.slice(-5); // Get last 5 elements, from low to high

        // Check if we successfully sliced the arrays
        if (!Array.isArray(focusedGroupTop5) || !Array.isArray(focusedGroupBottom5)) {
            return { focusedGroupTop5: [], focusedGroupBottom5: [], columnNames: [], otherGroupValues: [] };
        }

        // Extract column names from top and bottom of focusedGroup
        const columnNames = [...focusedGroupTop5, ...focusedGroupBottom5].map((item) => item.column_name);

        // Retrieve values from otherGroup for the corresponding column names
        const otherGroupValues = columnNames.map((columnName) => {
            const matchingItem = otherGroup.find((item) => item.column_name === columnName);
            return matchingItem ? matchingItem.average : null;
        });

        return { focusedGroupTop5, focusedGroupBottom5, columnNames, otherGroupValues };
    }

    // Utility function to get unique user IDs from a group
    const getUniqueUserIds = (group) => {
        return [...new Set(group.map(item => item.id))];
    }

    // Utility function to generate a random color
    const generateRandomColor = () => {
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        return { r, g, b }; // Return the RGB components as an object
    };

    // Update parseStrengthsData to use consistent colors
    const parseStrengthsData = (data, members) => {
        const teamStrengths = {
            labels: [],
            dataset: []
        };
        const keysToExclude = ['user_id'];

        data.forEach((item) => {
            const datasetRow = [];
            Object.keys(item).forEach((key) => {
                if (!keysToExclude.includes(key)) {
                    if (!teamStrengths.labels.includes(key)) {
                        teamStrengths.labels.push(key);
                    }
                    datasetRow.push(item[key]);
                }
            });
            if (datasetRow.length > 0) {
                teamStrengths.dataset.push({
                    data: datasetRow,
                    userId: item.user_id // Keep track of the user ID
                });
            }
        });

        return teamStrengths.dataset.map((datasetObj) => {
            const color = generateRandomColor();
            const rgbaColor = `rgba(${color.r},${color.g},${color.b}, 0.2)`;
            const borderColor = `rgb(${color.r},${color.g},${color.b})`;

            return {
                label: members.find(member => member.id === datasetObj.userId)?.name || t('analytics.tabs.teamStrengths'),
                backgroundColor: rgbaColor,
                borderColor: borderColor,
                pointBackgroundColor: borderColor,
                data: datasetObj.data
            };
        });
    };

// Update parseSalesData to use consistent colors
    const parseSalesData = (data, members) => {
        const salesStrengths = {
            Competency: [] ,
            Attitude: []
        };

        const membersRef = members.map(member => ({ ...member, color: generateRandomColor() }));

        data.forEach((item) => {
            Object.keys(item).forEach((key) => {
                if (key === 'Competency' || key === 'Attitude') {
                    const datasetRow = Object.values(item[key]);
                    salesStrengths[key].push({
                        data: datasetRow,
                        userId: item.user_id // Include user ID to reference the name
                    });
                }
            });
        });

        salesStrengths.Competency = salesStrengths.Competency?.map((datasetObj) => {
            const label = membersRef.find(member => member.id === datasetObj.userId)?.name || t('analytics.types.competency');
            const color = membersRef.find(member => member.id === datasetObj.userId)?.color || generateRandomColor();
            const rgbaColor = `rgba(${color.r},${color.g},${color.b}, 0.2)`;
            const borderColor = `rgb(${color.r},${color.g},${color.b})`;

            return {
                label: label, // Use the name from the map
                backgroundColor: rgbaColor,
                borderColor: borderColor,
                pointBackgroundColor: borderColor,
                data: datasetObj.data
            };
        }) || [];

        salesStrengths.Attitude = salesStrengths.Attitude?.map((datasetObj) => {
            const label = membersRef.find(member => member.id === datasetObj.userId)?.name || t('analytics.types.competency');
            const color = membersRef.find(member => member.id === datasetObj.userId)?.color || generateRandomColor();
            const rgbaColor = `rgba(${color.r},${color.g},${color.b}, 0.2)`;
            const borderColor = `rgb(${color.r},${color.g},${color.b})`;
            return {
                label: label, // Use the name from the map
                backgroundColor: rgbaColor,
                borderColor: borderColor,
                pointBackgroundColor: borderColor,
                data: datasetObj.data
            };
        }) || [];
        return salesStrengths;
    };

    // Handle team strengths data and update the state
    const handleTeamStrengthsData = (teamStrengthsData, uniqueGroupAIds, uniqueGroupBIds) => {
        const groupATeamStrengths = teamStrengthsData.filter(item => uniqueGroupAIds.includes(item.user_id));
        const groupATeamStrengthsParsed = parseStrengthsData(groupATeamStrengths, groupA);
        setGroupATeamChartData({
            labels: contentfulData?.teamStrengthsLabels,
            datasets: groupATeamStrengthsParsed
        });

        const groupBTeamStrengths = teamStrengthsData.filter(item => uniqueGroupBIds.includes(item.user_id));
        const groupBTeamStrengthsParsed = parseStrengthsData(groupBTeamStrengths, groupB);
        setGroupBTeamChartData({
            labels: contentfulData?.teamStrengthsLabels,
            datasets: groupBTeamStrengthsParsed
        });
    };

    // Handle sales strengths data and update the state
    const handleSalesStrengthsData = (salesStrengthsData, uniqueGroupAIds, uniqueGroupBIds) => {
        const groupASalesStrengths = salesStrengthsData.filter(item => uniqueGroupAIds.includes(item.user_id));
        const groupASalesDatasets = parseSalesData(groupASalesStrengths, groupA);
        setGroupASalesChartData({
            labels: contentfulData?.salesStrengthsLabels,
            datasets: groupASalesDatasets
        });

        const groupBSalesStrengths = salesStrengthsData.filter(item => uniqueGroupBIds.includes(item.user_id));
        const groupBSalesDatasets = parseSalesData(groupBSalesStrengths, groupB);
        setGroupBSalesChartData({
            labels: contentfulData?.salesStrengthsLabels,
            datasets: groupBSalesDatasets
        });
    };

    // Handle motivations comparative analysis
    const handleMotivationComparativeAnalysis = (motivationsData) => {
        const labels = motivationsData?.groupA?.map(item => item.column_name) || [];
        // Overall average for all metrics
        const overallAverages = {
            labels: convertLabelsToArrayOfWords(labels),
            datasets: [
                {
                    label: t('analytics.chartTitles.selectedGroupAverage'), // if only one group
                    data: motivationsData?.groupA?.map(item => item.average) || [],
                    backgroundColor: 'rgba(54, 162, 235, 0.2)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    pointBackgroundColor: 'rgba(54, 162, 235, 1)',
                }
            ]
        };
        if (motivationsData?.groupB) { // Only add if groupB data exists
            overallAverages.datasets[0].label = t('analytics.chartTitles.groupAAverage');
            overallAverages.datasets.push({
                    label: t('analytics.chartTitles.groupBAverage'),
                    data: motivationsData?.groupB?.map(item => item.average) || [],
                    backgroundColor: 'rgba(255, 99, 132, 0.2)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    pointBackgroundColor: 'rgba(255, 99, 132, 1)',
                }
            );
        }
        setAverageMotivationsData(overallAverages);

        // Group A focused
        const groupAFocused = formulateBarChartData(motivationsData, 'groupA', 'groupB');
        setMotivationsGroupAFocused({
            labels: groupAFocused.columnNames || [],
            groupAData: [...groupAFocused.focusedGroupTop5 || [], ...groupAFocused.focusedGroupBottom5 || []].map(item => item.average),
            groupBData: groupAFocused.otherGroupValues || []
        });

        // Group B focused
        const groupBFocused = formulateBarChartData(motivationsData, 'groupB', 'groupA');
        setMotivationsGroupBFocused({
            labels: groupBFocused.columnNames || [],
            groupAData: groupBFocused.otherGroupValues || [],
            groupBData: [...groupBFocused.focusedGroupTop5 || [], ...groupBFocused.focusedGroupBottom5 || []].map(item => item.average)
        });
    };

    // Handle competencies comparative analysis
    const handleCompetencyComparativeAnalysis = (competenciesData) => {
        const labels = competenciesData?.groupA?.map(item => item.column_name) || [];
        // Overall average for all metrics
        const overallAverages = {
            labels: convertLabelsToArrayOfWords(labels),
            datasets: [
                {
                    label: t('analytics.chartTitles.selectedGroupAverage'), // if only one group
                    data: competenciesData?.groupA?.map(item => item.average) || [],
                    backgroundColor: 'rgba(54, 162, 235, 0.2)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    pointBackgroundColor: 'rgba(54, 162, 235, 1)',
                }
            ]
        };
        if (competenciesData?.groupB) { // Only add if groupB data exists
            overallAverages.datasets[0].label = t('analytics.chartTitles.groupAAverage');
            overallAverages.datasets.push({
                    label: t('analytics.chartTitles.groupBAverage'),
                    data: competenciesData?.groupB?.map(item => item.average) || [],
                    backgroundColor: 'rgba(255, 99, 132, 0.2)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    pointBackgroundColor: 'rgba(255, 99, 132, 1)',
                }
            );
        }
        setAverageCompetenciesData(overallAverages);   

        // Group A focused
        const groupAFocused = formulateBarChartData(competenciesData, 'groupA', 'groupB');
        setCompetenciesGroupAFocused({
            labels: groupAFocused.columnNames || [],
            groupAData: [...groupAFocused.focusedGroupTop5 || [], ...groupAFocused.focusedGroupBottom5 || []].map(item => item.average),
            groupBData: groupAFocused.otherGroupValues || []
        });

        // Group B focused
        const groupBFocused = formulateBarChartData(competenciesData, 'groupB', 'groupA');
        setCompetenciesGroupBFocused({
            labels: groupBFocused.columnNames || [],
            groupAData: groupBFocused.otherGroupValues || [],
            groupBData: [...groupBFocused.focusedGroupTop5 || [], ...groupBFocused.focusedGroupBottom5 || []].map(item => item.average)
        });
    };

    //Handle behaviours comparative analysis
    const handleBehaviourComparativeAnalysis = (behavioursData) => {
        const labels = behavioursData?.groupA?.map(item => item.column_name) || [];
        // Overall average for all metrics
        const overallAverages = {
            labels: convertLabelsToArrayOfWords(labels),
            datasets: [
                {
                    label: t('analytics.chartTitles.selectedGroupAverage'), // if only one group
                    data: behavioursData?.groupA?.map(item => item.average) || [],
                    backgroundColor: 'rgba(54, 162, 235, 0.2)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    pointBackgroundColor: 'rgba(54, 162, 235, 1)',
                }
            ]
        };
        if (behavioursData?.groupB) { // Only add if groupB data exists
            overallAverages.datasets[0].label = t('analytics.chartTitles.groupAAverage');
            overallAverages.datasets.push({
                    label: t('analytics.chartTitles.groupBAverage'),
                    data: behavioursData?.groupB?.map(item => item.average) || [],
                    backgroundColor: 'rgba(255, 99, 132, 0.2)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    pointBackgroundColor: 'rgba(255, 99, 132, 1)',
                }
            );
        }
        setAverageBehavioursData(overallAverages);

        // Group A focused
        const groupAFocused = formulateBarChartData(behavioursData, 'groupA', 'groupB');
        setBehavioursGroupAFocused({
            labels: groupAFocused.columnNames || [],
            groupAData: [...groupAFocused.focusedGroupTop5 || [], ...groupAFocused.focusedGroupBottom5 || []].map(item => item.average),
            groupBData: groupAFocused.otherGroupValues || []
        });

        // Group B focused
        const groupBFocused = formulateBarChartData(behavioursData, 'groupB', 'groupA');
        setBehavioursGroupBFocused({
            labels: groupBFocused.columnNames || [],
            groupAData: groupBFocused.otherGroupValues || [],
            groupBData: [...groupBFocused.focusedGroupTop5 || [], ...groupBFocused.focusedGroupBottom5 || []].map(item => item.average)
        });
    }

    // Handle comparative analysis data for motivations and competencies IF ONLY ONE GROUP HAS DATA
    const handleComparativeAnalysis = (data) => {
        if (data.motivations_avg) {
            handleMotivationComparativeAnalysis(data.motivations_avg);
        }
        if (data.competencies_avg) {
            handleCompetencyComparativeAnalysis(data.competencies_avg);
        }
        if (data.behaviours_avg) {
            handleBehaviourComparativeAnalysis(data.behaviours_avg);
        }

        //ONLY ONE GROUP
        if(!data.motivations_avg.groupB){
            let sortedMotiv = data?.motivations_avg?.groupA?.sort((a,b) => b.average - a.average) || [];
            setTop5Motivations(sortedMotiv.slice(0,5));
            setBottom5Motivations(sortedMotiv.slice(-5));
        }

        if(!data.competencies_avg.groupB){
            let sortedComp = data?.competencies_avg?.groupA?.sort((a,b) => b.average - a.average) || [];
            setTop5Competencies(sortedComp.slice(0,5));
            setBottom5Competencies(sortedComp.slice(-5));
        }

        if(!data.behaviours_avg.groupB){
            let sortedBehav = data?.behaviours_avg?.groupA?.sort((a,b) => b.average - a.average) || [];
            setTop5Behaviours(sortedBehav.slice(0,5));
            setBottom5Behaviours(sortedBehav.slice(-5));
        }
    };

    const handleAllUserData = (data) => {

        const allGroupAUserCompetencies = {labels: [], datasets: []};
        const allGroupBUserCompetencies = {labels: [], datasets: []};
        let competenciesLabelIds = [];
        if (data.competencies_avg && data.competencies_avg?.groupA) {
            const competencyLabels = data.competencies_avg.groupA.map(item => item.column_name);
            allGroupAUserCompetencies.labels = convertLabelsToArrayOfWords(competencyLabels);
            allGroupBUserCompetencies.labels = convertLabelsToArrayOfWords(competencyLabels);
            // We want to show the metric scores exactly as per the order of labels above
            competenciesLabelIds = data.competencies_avg.groupA.map(item => item.column_id);
        }

        const allGroupAUserMotivations = {labels: [], datasets: []};
        const allGroupBUserMotivations = {labels: [], datasets: []};
        let motivationsLabelIds = [];
        if (data.motivations_avg && data.motivations_avg?.groupA) {
            const motivationLabels = data.motivations_avg.groupA.map(item => item.column_name);
            allGroupAUserMotivations.labels = convertLabelsToArrayOfWords(motivationLabels);
            allGroupBUserMotivations.labels = convertLabelsToArrayOfWords(motivationLabels);
            // We want to show the metric scores exactly as per the order of labels above
            motivationsLabelIds = data.motivations_avg.groupA.map(item => item.column_id);
        }

        const allGroupAUserBehaviours = {labels: [], datasets: []};
        const allGroupBUserBehaviours = {labels: [], datasets: []};
        let behavioursLabelIds = [];
        if (data.behaviours_avg && data.behaviours_avg?.groupA) {
            const behaviourLabels = data.behaviours_avg.groupA.map(item => item.column_name);
            allGroupAUserBehaviours.labels = convertLabelsToArrayOfWords(behaviourLabels);
            allGroupBUserBehaviours.labels = convertLabelsToArrayOfWords(behaviourLabels);
            // We want to show the metric scores exactly as per the order of labels above
            behavioursLabelIds = data.behaviours_avg.groupA.map(item => item.column_id);
        }

        const uniqueGroupAIds = getUniqueUserIds(groupA);
        const uniqueGroupBIds = getUniqueUserIds(groupB);

        if (data.all_user_data) {
            data.all_user_data.forEach(user => {
                // 1. Create a label for user by combinging first and last name
                const label = `${user.first_name} ${user.last_name}`;

                // 2. Create a color for the user to use consistently across charts
                const color = generateRandomColor();
                const rgbaColor = `rgba(${color.r},${color.g},${color.b}, 0.2)`;
                const borderColor = `rgb(${color.r},${color.g},${color.b})`;

                // 3. Prepare competencies data
                const competencyData = competenciesLabelIds.map(labelId => user.competencies?.[labelId] || 0);
                const competencyDatasetObj = {
                    label: label,
                    backgroundColor: rgbaColor,
                    borderColor: borderColor,
                    pointBackgroundColor: borderColor,
                    data: competencyData
                };

                // 4. Prepare motivations data
                const motivationData = motivationsLabelIds.map(labelId => user.motivations?.[labelId] || 0);
                const motivationDatasetObj = {
                    label: label,
                    backgroundColor: rgbaColor,
                    borderColor: borderColor,
                    pointBackgroundColor: borderColor,
                    data: motivationData
                };

                // 5. Prepare behaviours data
                const behaviourData = behavioursLabelIds.map(labelId => user.behaviours?.[labelId] || 0);
                const behaviourDatasetObj = {
                    label: label,
                    backgroundColor: rgbaColor,
                    borderColor: borderColor,
                    pointBackgroundColor: borderColor,
                    data: behaviourData
                };

                // 6. Assign datasets to respective groups
                if (uniqueGroupAIds.includes(user.user_id)) {
                    allGroupAUserCompetencies.datasets.push(competencyDatasetObj);
                    allGroupAUserMotivations.datasets.push(motivationDatasetObj);
                    allGroupAUserBehaviours.datasets.push(behaviourDatasetObj);
                } else if (uniqueGroupBIds.includes(user.user_id)) {
                    allGroupBUserCompetencies.datasets.push(competencyDatasetObj);
                    allGroupBUserMotivations.datasets.push(motivationDatasetObj);
                    allGroupBUserBehaviours.datasets.push(behaviourDatasetObj);
                }
            })
        }
        setAllGroupAUserCompetencies(allGroupAUserCompetencies);
        setAllGroupBUserCompetencies(allGroupBUserCompetencies);
        setAllGroupAUserMotivations(allGroupAUserMotivations);
        setAllGroupBUserMotivations(allGroupBUserMotivations);
        setAllGroupAUserBehaviours(allGroupAUserBehaviours);
        setAllGroupBUserBehaviours(allGroupBUserBehaviours);
    }

    const runTeamSimulation = async () => {
        // Clear all previous analysis data
        setAnalysisData(null);
        setGroupATeamChartData({ labels: contentfulData?.teamStrengthsLabels, datasets: [] });
        setGroupBTeamChartData({ labels: contentfulData?.teamStrengthsLabels, datasets: [] });
        setGroupASalesChartData({ labels: contentfulData?.salesStrengthsLabels, datasets: { Competency: [], Attitude: [] } });
        setGroupBSalesChartData({ labels: contentfulData?.salesStrengthsLabels, datasets: { Competency: [], Attitude: [] } });
        setTop5Competencies([]);
        setBottom5Competencies([]);
        setCompetenciesGroupAFocused({ labels: [], groupAData: [], groupBData: [] });
        setCompetenciesGroupBFocused({ labels: [], groupAData: [], groupBData: [] });
        setTop5Motivations([]);
        setBottom5Motivations([]);
        setMotivationsGroupAFocused({ labels: [], groupAData: [], groupBData: [] });
        setMotivationsGroupBFocused({ labels: [], groupAData: [], groupBData: [] });

        let uniqueGroupAIds, uniqueGroupBIds;
        // If either group is empty, send all IDs as groupA, and groupB as an empty array
        if (groupA.length === 0 || groupB.length === 0) {
            setGroupA([...groupA, ...groupB]);
            setGroupB([]);
            uniqueGroupAIds = getUniqueUserIds([...groupA, ...groupB]);
            uniqueGroupBIds = [];
        } else {
            uniqueGroupAIds = getUniqueUserIds(groupA);
            uniqueGroupBIds = getUniqueUserIds(groupB);
        }

        /// Fetch data from the API
        try {
            const res = await b2bServiceObj.GetTeamAnalysisData({
                groupa: uniqueGroupAIds,
                groupb: uniqueGroupBIds
            });
            if (res?.httpStatus === 200 && res.json?.data) {
                const data = res.json.data;
                setAnalysisData(data);
                try {
                    handleTeamStrengthsData(data.team_strengths, uniqueGroupAIds, uniqueGroupBIds);
                    handleSalesStrengthsData(data.sales_strengths, uniqueGroupAIds, uniqueGroupBIds);
                    handleComparativeAnalysis(data);
                    handleAllUserData(data);
                } catch (processingError) {
                    console.error("Data processing error:", processingError);
                    setFetchDataErrorMessage(t('simulator.processError'));
                }
                setFetchDataErrorMessage("");
            } else {
                setFetchDataErrorMessage(t('simulator.serverError'));
            }
        } catch (apiError) {
            setFetchDataErrorMessage(t('simulator.systemError'));
        } finally {
            setGroupEditedFlag(false);
        }
    };
    
    return (
        <div className="page-wrapper">
            <div className="bg-cover">
                <div className='desktop-layout d-none d-lg-block m-0 mb-5'>
                    <div className="team-simulator-full-view">
                        <ControlPanel 
                            selectedCandidates={selectedCandidates}
                            setSelectedCandidates={setSelectedCandidates}
                            groupA={groupA}
                            setGroupA={setGroupA} 
                            groupB={groupB}
                            setGroupB={setGroupB} 
                            groupEditedFlag={groupEditedFlag}
                            setGroupEditedFlag={setGroupEditedFlag}
                            runTeamSimulation={runTeamSimulation}
                            fetchDataErrorMessage={fetchDataErrorMessage}
                            setFetchDataErrorMessage={setFetchDataErrorMessage}
                        ></ControlPanel>
                    </div>

                {analysisData && <div className="charts-div-background">

                    {/* COMPETENCIES ANALYSIS */}
                    {analysisData?.competencies_avg &&
                        <div className='charts-div'>
                            {/* Only show the scroll instruction if there is group B chart */}
                            {allGroupBUserCompetencies && allGroupBUserCompetencies.datasets?.length > 0 && (
                                <p className="s bold" style={{ color: 'red' }}>{t('simulator.scrollCharts')}</p>
                            )}
                            <div className="charts-container-div flex p-20 bottom">
                                {analysisData?.competencies_avg?.groupA &&
                                    <div className='radar-charts-div' style={{flexDirection: "column"}}>           
                                        <RadarChart
                                            title={t('analytics.chartTitles.averageMetric', { metric: t('talents.sections.workStyles') })}
                                            data={averageCompetenciesData}
                                            options={lightOptionsTeams}
                                            width={'600px'}
                                            height={'600px'}
                                        />
                                    </div>
                                }
                                {allGroupAUserCompetencies && allGroupAUserCompetencies.datasets?.length > 0 &&
                                    <div className='radar-charts-div' style={{flexDirection: "column"}}>
                                        <RadarChart
                                            title={groupB?.length > 0 ? t('analytics.chartTitles.groupAIndividualMetric', { metric: t('talents.sections.workStyles') }) : t('analytics.chartTitles.individualMetric', { metric: t('talents.sections.workStyles') })}
                                            data={allGroupAUserCompetencies}
                                            options={lightOptionsTeams}
                                            width={'600px'}
                                            height={'600px'}
                                        />
                                    </div>
                                }
                                {allGroupBUserCompetencies && allGroupBUserCompetencies.datasets?.length > 0 &&
                                    <div className='radar-charts-div' style={{flexDirection: "column"}}>           
                                        <RadarChart
                                            title={t('analytics.chartTitles.groupBIndividualMetric', { metric: t('talents.sections.workStyles') })}
                                            data={allGroupBUserCompetencies}
                                            options={lightOptionsTeams}
                                            width={'600px'}
                                            height={'600px'}
                                        />
                                    </div>
                                }
                            </div>
                            <p className="s center bold mar-20">{t('simulator.clickLabels')}</p>
                        </div>
                    }
                    {analysisData?.competencies_avg?.groupA && analysisData?.competencies_avg?.groupB &&
                        <>
                        <div className='charts-div'>
                            <TeamSimulatorVerticalCharts
                                chartTitle={t('simulator.highlightsGroupAFocused', { metric: t('talents.sections.workStyles') })}
                                isGroupAFocused={true}
                                labels={competenciesGroupAFocused.labels || []}
                                groupAData={competenciesGroupAFocused.groupAData || []}
                                groupBData={competenciesGroupAFocused.groupBData || []}
                                leftChartLabel={t('simulator.groupA')}
                                rightChartLabel={t('simulator.groupBCorresponding')}
                            />
                        </div>
                        <div className='charts-div'>
                            <TeamSimulatorVerticalCharts
                                chartTitle={t('simulator.highlightsGroupBFocused', { metric: t('talents.sections.workStyles') })}
                                isGroupAFocused={false}
                                labels={competenciesGroupBFocused.labels || []}
                                groupAData={competenciesGroupBFocused.groupAData || []}
                                groupBData={competenciesGroupBFocused.groupBData || []}
                                leftChartLabel={t('simulator.groupACorresponding')}
                                rightChartLabel={t('simulator.groupB')}
                            />
                        </div>
                    </>}
                    {analysisData?.competencies_avg?.groupA && !analysisData?.competencies_avg?.groupB &&
                        <div className='charts-div'>
                            <CommonCompetencies 
                                title={t('analytics.chartTitles.metricHighlights', { metric: t('talents.sections.workStyles') })} 
                                commonComp={top5Competencies} 
                                missingComp={bottom5Competencies}
                                isLegendVisible={true}
                            />
                        </div>
                    }


                    {/* MOTIVATIONS ANALYSIS */}
                    {analysisData?.motivations_avg &&
                        <div className='charts-div'>
                            {/* Only show the scroll instruction if there is group B chart */}
                            {allGroupBUserMotivations && allGroupBUserMotivations.datasets?.length > 0 && (
                                <p className="s bold" style={{ color: 'red' }}>{t('simulator.scrollCharts')}</p>
                            )}
                            <div className="charts-container-div flex p-20 bottom">
                                {analysisData?.motivations_avg?.groupA &&
                                    <div className='radar-charts-div' style={{flexDirection: "column"}}>           
                                        <RadarChart
                                            title={t('analytics.chartTitles.averageMetric', { metric: t('analytics.chartTitles.valuesMotivations') })}
                                            data={averageMotivationsData}
                                            options={lightOptionsTeams}
                                            width={'600px'}
                                            height={'600px'}
                                        />
                                    </div>
                                }
                                {allGroupAUserMotivations && allGroupAUserMotivations.datasets?.length > 0 &&
                                    <div className='radar-charts-div' style={{flexDirection: "column"}}>
                                        <RadarChart
                                            title={groupB?.length > 0 ? t('analytics.chartTitles.groupAIndividualMetric', { metric: t('analytics.chartTitles.valuesMotivations') }) : t('analytics.chartTitles.individualMetric', { metric: t('analytics.chartTitles.valuesMotivations') })}
                                            data={allGroupAUserMotivations}
                                            options={lightOptionsTeams}
                                            width={'600px'}
                                            height={'600px'}
                                        />
                                    </div>
                                }
                                {allGroupBUserMotivations && allGroupBUserMotivations.datasets?.length > 0 &&
                                    <div className='radar-charts-div' style={{flexDirection: "column"}}>           
                                        <RadarChart
                                            title={t('analytics.chartTitles.groupBIndividualMetric', { metric: t('analytics.chartTitles.valuesMotivations') })}
                                            data={allGroupBUserMotivations}
                                            options={lightOptionsTeams}
                                            width={'600px'}
                                            height={'600px'}
                                        />
                                    </div>
                                }
                            </div>
                            <p className="s center bold mar-20">{t('simulator.clickLabels')}</p>
                        </div>
                    }
                    {analysisData?.motivations_avg?.groupA && analysisData?.motivations_avg?.groupB &&
                        <>
                        <div className='charts-div'>
                            <TeamSimulatorVerticalCharts
                                chartTitle={t('simulator.highlightsGroupAFocused', { metric: t('analytics.chartTitles.valuesMotivation') })}
                                isGroupAFocused={true}
                                labels={motivationsGroupAFocused.labels || []}
                                groupAData={motivationsGroupAFocused.groupAData || []}
                                groupBData={motivationsGroupAFocused.groupBData || []}
                                leftChartLabel={t('simulator.groupA')}
                                rightChartLabel={t('simulator.groupBCorresponding')}
                            />
                        </div>
                        <div className='charts-div'>
                            <TeamSimulatorVerticalCharts
                                chartTitle={t('simulator.highlightsGroupBFocused', { metric: t('analytics.chartTitles.valuesMotivation') })}
                                isGroupAFocused={false}
                                labels={motivationsGroupBFocused.labels || []}
                                groupAData={motivationsGroupBFocused.groupAData || []}
                                groupBData={motivationsGroupBFocused.groupBData || []}
                                leftChartLabel={t('simulator.groupACorresponding')}
                                rightChartLabel={t('simulator.groupB')}
                            />
                        </div>
                    </>}
                    {analysisData?.motivations_avg?.groupA && !analysisData?.motivations_avg?.groupB &&
                        <div className='charts-div'>
                            <MotivationCharts 
                                title={t('analytics.chartTitles.metricHighlights', { metric: t('analytics.chartTitles.valuesMotivations') })} 
                                topMotivations={top5Motivations} 
                                lowMotivations={bottom5Motivations}
                                isLegendVisible={true}
                            />
                        </div>
                    }

                    {/* BEHAVIOURS ANALYSIS */}
                    {analysisData?.behaviours_avg &&
                        <div className='charts-div'>
                            {/* Only show the scroll instruction if there is group B chart */}
                            {allGroupBUserBehaviours && allGroupBUserBehaviours.datasets?.length > 0 && (
                                <p className="s bold" style={{ color: 'red' }}>{t('simulator.scrollCharts')}</p>
                            )}
                            <div className="charts-container-div flex p-20 bottom">
                                {analysisData?.behaviours_avg?.groupA &&
                                    <div className='radar-charts-div' style={{flexDirection: "column"}}>           
                                        <RadarChart
                                            title={t('analytics.chartTitles.averageMetric', { metric: t('analytics.tabs.behaviours') })}
                                            data={averageBehavioursData}
                                            options={lightOptionsTeams}
                                            width={'600px'}
                                            height={'600px'}
                                        />
                                    </div>
                                }
                                {allGroupAUserBehaviours && allGroupAUserBehaviours.datasets?.length > 0 &&
                                    <div className='radar-charts-div' style={{flexDirection: "column"}}>
                                        <RadarChart
                                            title={groupB?.length > 0 ? t('analytics.chartTitles.groupAIndividualMetric', { metric: t('analytics.tabs.behaviours') }) : t('analytics.chartTitles.individualMetric', { metric: t('analytics.tabs.behaviours') })}
                                            data={allGroupAUserBehaviours}
                                            options={lightOptionsTeams}
                                            width={'600px'}
                                            height={'600px'}
                                        />
                                    </div>
                                }
                                {allGroupBUserBehaviours && allGroupBUserBehaviours.datasets?.length > 0 &&
                                    <div className='radar-charts-div' style={{flexDirection: "column"}}>           
                                        <RadarChart
                                            title={t('analytics.chartTitles.groupBIndividualMetric', { metric: t('analytics.tabs.behaviours') })}
                                            data={allGroupBUserBehaviours}
                                            options={lightOptionsTeams}
                                            width={'600px'}
                                            height={'600px'}
                                        />
                                    </div>
                                }
                            </div>
                            <p className="s center bold mar-20">{t('simulator.clickLabels')}</p>
                        </div>
                    }
                    {analysisData?.behaviours_avg?.groupA && analysisData?.behaviours_avg?.groupB &&
                        <>
                        <div className='charts-div'>
                            <TeamSimulatorVerticalCharts
                                chartTitle={t('simulator.highlightsGroupAFocused', { metric: t('analytics.tabs.behaviours') })}
                                isGroupAFocused={true}
                                labels={behavioursGroupAFocused.labels || []}
                                groupAData={behavioursGroupAFocused.groupAData || []}
                                groupBData={behavioursGroupAFocused.groupBData || []}
                                leftChartLabel={t('simulator.groupA')}
                                rightChartLabel={t('simulator.groupBCorresponding')}
                            />
                        </div>
                        <div className='charts-div'>
                            <TeamSimulatorVerticalCharts
                                chartTitle={t('simulator.highlightsGroupBFocused', { metric: t('analytics.tabs.behaviours') })}
                                isGroupAFocused={false}
                                labels={behavioursGroupBFocused.labels || []}
                                groupAData={behavioursGroupBFocused.groupAData || []}
                                groupBData={behavioursGroupBFocused.groupBData || []}
                                leftChartLabel={t('simulator.groupACorresponding')}
                                rightChartLabel={t('simulator.groupB')}
                            />
                        </div>
                    </>}
                    {analysisData?.behaviours_avg?.groupA && !analysisData?.behaviours_avg?.groupB &&
                        <div className='charts-div'>
                            <CommonBehaviours 
                                title={t('analytics.chartTitles.metricHighlights', { metric: t('analytics.tabs.behaviours') })} 
                                commonBehaviours={top5Behaviours} 
                                missingBehaviours={bottom5Behaviours}
                                isLegendVisible={true}
                            />
                        </div>
                    }

                    {/* TEAM STRENGTHS ANALYSIS */}
                    {companyData?.country === Constants.COUNTRY_CODE_FINLAND && groupATeamChartData.datasets?.length > 0 && (
                        <div className='charts-div'>
                            <div className="flex">
                                <div className='radar-charts-div' style={{flexDirection: "column"}}>
                                    <RadarChart
                                        title={groupB?.length > 0 ? t('analytics.chartTitles.groupAMetric', { metric: t('analytics.tabs.teamStrengths') }) : t('analytics.tabs.teamStrengths')}
                                        data={groupATeamChartData}
                                        options={lightOptionsTeams}
                                        width={'600px'}
                                        height={'600px'}
                                    />
                                </div>
                                {groupBTeamChartData.datasets?.length > 0 &&
                                <div className='radar-charts-div' style={{flexDirection: "column"}}>           
                                    <RadarChart
                                        title={t('analytics.chartTitles.groupBMetric', { metric: t('analytics.tabs.teamStrengths') })}
                                        data={groupBTeamChartData}
                                        options={lightOptionsTeams}
                                        width={'600px'}
                                        height={'600px'}
                                    />
                                </div>}
                            </div>
                            <p className="s center bold mar-20">{t('simulator.clickLabels')}</p>
                        </div>
                    )}

                    {companyData?.country === Constants.COUNTRY_CODE_FINLAND &&groupASalesChartData.datasets?.Competency?.length > 0 &&
                        <div className='charts-div'>
                            <div className="flex">
                                <div className='radar-charts-div' style={{flexDirection: "column"}}>
                                    <div style={{alignSelf: 'flex-end'}}>
                                        <Select
                                            options={optionsSalesDropdown}
                                            handleChange={(e) => setGroupASalesOption(e.target.value)}
                                            option={groupASalesOption}
                                        />
                                    </div>
                                    <RadarChart
                                        title={groupB?.length > 0 ? t('analytics.chartTitles.groupAMetric', { metric: t('analytics.tabs.salesStrengths') }) : t('analytics.tabs.salesStrengths')}
                                        data={{
                                            labels: groupASalesChartData.labels,
                                            datasets: groupASalesChartData.datasets[groupASalesOption]
                                        }}
                                        options={lightOptionsSales}
                                        width={'600px'}
                                        height={'600px'}
                                    />
                                </div>
                                
                                {groupBSalesChartData.datasets?.Competency?.length > 0 &&
                                    <div className='radar-charts-div' style={{flexDirection: "column"}}>
                                        <div style={{alignSelf: 'flex-end'}}>
                                            <Select
                                                options={optionsSalesDropdown}
                                                handleChange={(e) => setGroupBSalesOption(e.target.value)}
                                                option={groupBSalesOption}
                                            />
                                        </div>

                                        <RadarChart
                                            title={t('analytics.chartTitles.groupBMetric', { metric: t('analytics.tabs.salesStrengths') })}
                                            data={{
                                                labels: groupBSalesChartData.labels,
                                                datasets: groupBSalesChartData.datasets[groupBSalesOption]
                                            }}
                                            options={lightOptionsSales}
                                            width={'600px'}
                                            height={'600px'}
                                        />
                                    </div>
                                }
                            </div>
                            <p className="s center bold mar-20">{t('simulator.clickLabels')}</p>
                        </div>
                    }

                    </div>}
                </div>
            </div>
        </div>
    )
}

export default TeamSimulatorPage;




